import React, { useContext } from 'react';
import { constructUrl } from '../../../utils/UrlConstructor';
import './CartItem.css'
import { AddToCartContext } from './AddToCartContext';
import { formatPriceString } from '../modals/product/extended-product-modal/util/ProductModalHelpers';
import { QuantitySelectorClicked } from '../../../utils/Analytics.js';


const CartItem = ({ title, price, size, quantity, variantId, titleAndSize, thumbnail, menuTextFontStyle, prefix, sku, baseSKU }) => {
    const { addToCart, updateFromCart, removeFromCart, cartSubTotal, setCartSubTotal, cartList } = useContext(AddToCartContext);

    const UpdateItemQuantity = () => {
        QuantitySelectorClicked(title, baseSKU, 'increase')
        const productTitleAndSize = `${title}_${size}`;
        let productItemInfo = cartList.find(item => item.TITLE_AND_SIZE === productTitleAndSize);
     
        addToCart({
            TITLE: title,
            SIZE: size,
            TITLE_AND_SIZE: productTitleAndSize,
            PRICE: price,
            DOWNSIZED_THUMBNAIL: thumbnail,
            VARIANT_ID: variantId,
            QUANTITY: (productItemInfo && productItemInfo.QUANTITY) ? (productItemInfo.QUANTITY + 1) : 1
        });
        const subTotal = cartSubTotal + parseFloat(price);         
        setCartSubTotal(subTotal);
    }

    const decreaseItemQuantity = () => {
        QuantitySelectorClicked(title, baseSKU, 'decrease')
        const productTitleAndSize = `${title}_${size}`;
        if(quantity === 1){
            removeFromCart(productTitleAndSize);
        } else {            
            updateFromCart(productTitleAndSize);
        }
        const subTotal = cartSubTotal - parseFloat(price);         
        setCartSubTotal(subTotal);
    }

    return (
        <React.Fragment>
            <div className='cart-item-container'>
                {thumbnail && <img className='cart-item-thumbnail' src={constructUrl(thumbnail)} />}
                {!thumbnail && <div className='cart-item-thumbnail'>&nbsp;</div>}
                <div className='cart-item-info' style={{...menuTextFontStyle,fontFamily:'OpenSans-Bold'}}>
                    <span className="cart-product-title">{title}</span>
                    {size === "Default Title" ? null : <span className="cart-product-size">Size: {size}</span>}  
                    <span className="cart-product-title">1 X {formatPriceString(price,prefix)}</span>
                    <div className="input-group cart-quantity-box">
                        <input type="button" value="-" className="button-minus" data-field="quantity" onClick={decreaseItemQuantity} />
                        <span style={{fontFamily:'OpenSans-Bold'}}>{quantity}</span>
                        <input type="button" value="+" className="button-plus" data-field="quantity" onClick={UpdateItemQuantity}/>
                    </div>       
                </div>
            </div>
        {/* <div className='cart-item-remove' onClick={() => removeFromCart(titleAndSize)}>Remove</div> */}
        <hr className="cart-item-break" />
       
    </React.Fragment>

    )
}

export default CartItem;
